// Analytics utility for tracking user events
// Integrates with Google Analytics 4, Facebook Pixel, etc.

type EventProperties = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    fbq: (...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, properties?: EventProperties) => {
  // Log to console in development
  if (import.meta.env.DEV) {
    console.log('[Analytics]', eventName, properties);
  }

  // Google Analytics 4 (gtag)
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, properties);
  }

  // Facebook Pixel
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, properties);
  }
};

export const trackPageView = (path: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
};

// Predefined events for consistency
export const AnalyticsEvents = {
  DOWNLOAD_EMISSIONS_SUMMARY: 'download_emissions_summary',
  EMISSIONS_SEARCH: 'emissions_search',
  CONTACT_FORM_SUBMIT: 'contact_form_submit',
  CTA_CLICK: 'cta_click',
  PAGE_VIEW: 'page_view',
} as const;
